export default __webpack_public_path__ + "7799d59.png";